import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Shared by SessionForm, FindSession and StrangerRegister so the list of session types
 * (romantic/friendship/creative, plus anything an admin adds via Content Management) is a
 * single source of truth instead of three hardcoded arrays. */
export const useSessionTypes = () => {
  const [types, setTypes] = useState([]);
  useEffect(() => {
    api
      .get("/content/session-types")
      .then(({ data }) => setTypes(data))
      .catch(() => {});
  }, []);
  return types;
};
